// Footer
(function () {
  const $buttons = document.querySelectorAll('.footer__item--links .footer__item-title');

  $buttons.forEach($button => {
    $button.addEventListener('click', () => {
      if (window.innerWidth > 768) return;

      const $parent = $button.parentElement;
      $parent.classList.toggle('open');

      const $content = $button.nextElementSibling;
      if($parent.classList.contains('open')) {
        $content.style.maxHeight = $content.scrollHeight + 'px';
      } else {
        $content.style.maxHeight = 0;
      }
    })
  });
})()

async function fetchCart() {
  const response = await fetch('/cart.js');
  return response.json();
}

function calcDiscountPrice(localDataOrder, items) {
  let totalDiscountPrice = 0;
  items.forEach(productItem => {
    if (!!productItem.properties && !!productItem.properties.offer) {
      const lineItemProperty = localDataOrder.find(product => product.propertyId === productItem.properties.offer);
      if (lineItemProperty && +lineItemProperty.discountValue) {
        let productPrice = productItem.discounted_price / 100;
        if (lineItemProperty.discountType === '%') {
          productPrice = (+productPrice - (+productPrice * +lineItemProperty.discountValue / 100)).toFixed(2);
        } else {
          productPrice = (+productPrice - +lineItemProperty.discountValue).toFixed(2);
        }
        totalDiscountPrice += productPrice * Math.min(productItem.quantity, lineItemProperty.qty);
      } else {
        totalDiscountPrice += (productItem.discounted_price / 100) * productItem.quantity;
      }
    } else {
      totalDiscountPrice += (productItem.discounted_price / 100) * productItem.quantity;
    }
  })
  return totalDiscountPrice;
}

async function calculateTotalPriceWithDiscount() {
  const localDataOrder = JSON.parse(localStorage.getItem('kaktusDataOrder'));
  const {items} = await fetchCart();
  if (items.length) {
    return calcDiscountPrice(localDataOrder, items);
  }
  return 0;
}

function updatePricesforDiscount() {
  calculateTotalPriceWithDiscount().then(totalDiscountPrice => {
    const totalDiscountPriceElement = document.querySelector('.js-total-discount-price');
    const priceDifferenceElement = document.querySelector('.js-price-difference');
    // const totalDiscountPriceElementWrap = document.querySelector('.js-total-discount-price__wrap');
    const priceDifferenceElementWrap = document.querySelector('.js-price-difference__wrap');
    const finalSum = document.querySelector('.final_sum');

    fetchCart().then(cart => {
      const totalPrice = cart.total_price / 100;
      const priceDifference = totalPrice - totalDiscountPrice;

      if (priceDifference > 0.01) {
        if (totalDiscountPriceElement){
          totalDiscountPriceElement.style.display = 'flex';
          totalDiscountPriceElement.textContent = '€' + (totalDiscountPrice.toFixed(2).replace('.', ','));
        }
        if (priceDifferenceElement) {
          priceDifferenceElementWrap.style.display = 'flex';
          priceDifferenceElement.textContent = '- €' + (priceDifference.toFixed(2).replace('.', ','));
        }
        if (finalSum) {
           finalSum.style.textDecoration = 'line-through'
        }

      }else {
        if (totalDiscountPriceElement){
          totalDiscountPriceElement.style.display = 'none';
        }
        if (priceDifferenceElement) {
          priceDifferenceElementWrap.style.display = 'none';
        }
        if (finalSum) {
          finalSum.style.textDecoration = 'none'
        }
      }
    });
  });
}
// Prio-Product

document.addEventListener('DOMContentLoaded', addTogglePrioProductListener);
document.addEventListener('DOMContentLoaded', removePrioProductIfThresholdReached);
document.addEventListener('cart:refresh', () => {
  removePrioProductIfThresholdReached()
});
// const observer = new MutationObserver(function (mutations) {
//   mutations.forEach(function (mutation) {
//     if (mutation.type === 'childList') {
//       addTogglePrioProductListener();
//     }
//   });
// });

// observer.observe(document.body, {
//   childList: true,
//   subtree: true
// });

function addTogglePrioProductListener() {
  const toggle = document.getElementById('upcart-addons-toggle');
  if (toggle && !toggle.getAttribute('data-listener-added')) {
    toggle.addEventListener('click', togglePrioProduct);
    toggle.setAttribute('data-listener-added', 'true');
  }
}

function togglePrioProduct() {
  const prioProductData = document.getElementById('prio-product-data');

  if (!prioProductData) {
    console.warn('prio-product-data element not found.');
    return;
  }

  const prioProductId = prioProductData.dataset.variantId;
  const toggle = document.getElementById('upcart-addons-toggle');
  let isActive = toggle.classList.contains('active');

  function addPrioProductToCart() {
    const url = '/cart/add.js';
    const data = {
      id: prioProductId,
      quantity: 1
    };
    return fetch(url, {
      method: 'POST',
      body: JSON.stringify(data),
      headers: {
        'Content-Type': 'application/json'
      }
    })
        .then(response => response.json())
        .catch(error => console.error(error));
  }

  function removePrioProductFromCart() {
    const url = `/cart/change.js`;
    const data = {
      id: prioProductId,
      quantity: 0
    };
    return fetch(url, {
      method: 'POST',
      body: JSON.stringify(data),
      headers: {
        'Content-Type': 'application/json'
      }
    })
        .then(response => response.json())
        .catch(error => console.error(error));
  }

  if (isActive) {
    removePrioProductFromCart().then(() => {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
      }));
      toggle.classList.toggle('active');
    });
  } else {
    addPrioProductToCart().then(() => {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
      }));
      toggle.classList.toggle('active');
    });
  }
}

function removePrioProductIfThresholdReached() {
  const prioProductData = document.getElementById('prio-product-data');
  if (!prioProductData) {
    console.warn('prio-product-data element not found.');
    return;
  }
  const showPrioProductFreeshipping = prioProductData.dataset.showFreeshipping === 'true';
  const thresholdInCents = parseInt(prioProductData.dataset.thresholdInCents, 10);
  const prioProductVariantId = prioProductData.dataset.variantId;
  if (!showPrioProductFreeshipping) {
    return;
  }

  fetch("/cart.js")
      .then(response => response.json())
      .then(cart => {
        if (cart.total_price < thresholdInCents) {
          const itemToRemove = cart.items.find(item => item.variant_id == prioProductVariantId);

          if (itemToRemove) {
            const url = `/cart/change.js`;
            const data = {
              id: prioProductVariantId,
              quantity: 0
            };
            fetch(url, {
              method: 'POST',
              body: JSON.stringify(data),
              headers: {
                'Content-Type': 'application/json'
              }
            })
                .then(response => {
                  if (!response.ok) {
                    throw new Error(`HTTP error ${response.status}`);
                  }
                  document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                    bubbles: true}));
                  return response.json();
                })
                .catch(error => console.error(error));

          }
        }
      });
}


// Функція для додавання слухача подій
function handleClick(element) {
  let kaktusApp = document.querySelector('div[id^="kaktusv-app"]');
  if (kaktusApp) {
    element.classList.toggle('active');

    if (element.classList.contains('active')) {
      kaktusApp.classList.add('show');
    } else {
      kaktusApp.classList.remove('show');
    }
  }
}


// COPY TEXT BUTTON
let copyBtns = document.querySelectorAll('.copy-discount-code');

const copyContent = async (text,btn) => {
  try {
    await navigator.clipboard.writeText(text);
    btn.textContent = 'Kopiert!';
  } catch (err) {
    alert('Failed to copy: ', err);
  }
}

if(copyBtns.length > 0){
  copyBtns.forEach((btn)=>{
    btn.addEventListener('click',()=>{
      let code = btn.getAttribute('data-discount-code');
      copyContent(code,btn);
    })
  })
}




// NEW MOBILE menu

class MobileMenuWindow extends HTMLElement{
  constructor(){
    super();
    this.toPrevStepBtn = this.querySelector('.to-prev-step-btn');
    this.closeBtn = this.querySelector('.close-menu-btn');
    this.windowTriggerBtn = this.parentNode.querySelector('button.mobile-nav__link');
    this.allWindows = document.querySelectorAll('mobile-navigation mobile-menu-window');

    this.toPrevStepBtn.addEventListener('click',this.toPrevStep.bind(this));
    this.closeBtn.addEventListener('click',this.closeMenu.bind(this))
  }

  toPrevStep(){
    this.windowTriggerBtn.setAttribute('aria-expanded', 'false');
  }

  closeMenu(){
    if(document.querySelector("#mobile-menu-drawer")){
      document.querySelector("#mobile-menu-drawer").open = false;
    }

    setTimeout(()=>{
      this.allWindows.forEach((elem)=>{
        elem.parentNode.querySelector('button.mobile-nav__link').setAttribute('aria-expanded', 'false');
      })
      document.querySelector("#mobile-menu-drawer > div").scrollTo(0,0);
    },600)
  }
}

customElements.define('mobile-menu-window', MobileMenuWindow)